import { AxiosError } from 'axios'
import * as EN from '../../constants/en.json'
import { IAxiosErrorWrapper, IGenericResponse } from '../../types/service-types'

export const axiosErrorWrapper = (
  exception: AxiosError<IGenericResponse<null>>,
): IAxiosErrorWrapper => {
  const error: IAxiosErrorWrapper = {
    code: exception?.response?.data.error || exception.code,
    status: exception?.response?.data.status || exception?.response?.status || 0,
    message: exception?.response?.data.message || exception.message,
    request: exception?.request,
    response: exception?.response,
  }

  /* When Axios is not able to provide a response
     provide a meaning message to the user */

  if (error.code === 'ERR_NETWORK') {
    error.message = EN.serviceError.NETWORK_ERROR
  }

  if (error.status === 400 || error.code === 'ERR_BAD_REQUEST') {
    error.message = EN.serviceError.BAD_REQUEST
  }

  return error
}
